export function getCorrectTimeFormat({ hours = 0, minutes = 0, seconds }, culture) {
    return culture === "nb" ?
        [`${hours}\ntimer`, `${minutes}\nmin`, `${seconds}\nsek`] :
        [`${hours}\nhours`, `${minutes}\nmin`, `${seconds}\nsec`];
}
export function getTimeRemainingSecond(secondsTillEnd) {
    var _a;
    const culture = (_a = document.body.dataset.uiculture) !== null && _a !== void 0 ? _a : "";
    const days = Math.floor(secondsTillEnd / 86400);
    secondsTillEnd -= days * 86400;
    const hours = Math.floor(secondsTillEnd / 3600) % 24;
    secondsTillEnd -= hours * 3600;
    const minutes = Math.floor(secondsTillEnd / 60) % 60;
    secondsTillEnd -= minutes * 60;
    const seconds = secondsTillEnd % 60;
    return getCorrectTimeFormat({ hours, minutes, seconds }, culture);
}
